import { Component, Inject, OnInit } from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';

@Component({
  selector: 'app-cooking-story-members-share',
  templateUrl: './cooking-story-members-share.component.html',
  styleUrls: ['./cooking-story-members-share.component.scss'],
})
export class CookingStoryMembersShareComponent implements OnInit {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };
  url;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      id: string;
    },
    private bottomSheetRef: MatBottomSheetRef<CookingStoryMembersShareComponent>,
    private matBottomSheet: MatBottomSheet,
    private snackBarService: SnackBarService
  ) {}

  ngOnInit(): void {
    this.url = `https://bentoapp.org/deeplink/home/invite?id=${this.data.id}&market=pwa`;
  }
  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.bottomSheetRef.dismiss();
    }
  }
  goBack() {
    this.bottomSheetRef.dismiss();
  }
  share() {
    let newVariable: any;
    newVariable = window.navigator;
    if (newVariable && newVariable.share) {
      newVariable
        .share({
          url: this.url,
        })
        .catch((e) => {
          this.snackBarService.showSnackBar('خطا در اشتراک گذاری');
        });
    } else {
      // this.snackBarService.showSnackBar('اشتراک گذاری در جست‌و‌جوگر شما پشتیبانی نمیشود');
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = this.url;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.snackBarService.showSnackBar('لینک دعوت کپی شد');
    }
    this.bottomSheetRef.dismiss();
  }
  copy() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.url;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snackBarService.showSnackBar('لینک دعوت کپی شد');
  }
}
